export const ADD_USERNAME = 'ADD_USERNAME';
export const ADD_SECURITY_CODE = 'ADD_SECURITY_CODE';

type AuthOTPActionType = typeof ADD_USERNAME| typeof ADD_SECURITY_CODE;

export interface AuthOTPAction {
    type: AuthOTPActionType;
    payload: any;
}

export interface AuthOTPState {
    identification: string,
    otp: string
}
